namespace $ {

	$mol_style_attach( '$shm_projects_image_viewer_popover', `
		[shm_projects_image_viewer_preview] img {
			cursor: zoom-in;
		}

		[shm_projects_image_viewer_bubble] {
			inset: 0 !important;
			width: 100vw !important;
			height: 100dvh !important;
			max-width: none !important;
			max-height: none !important;
			margin: 0 !important;
			border-radius: 0 !important;
			transform: none !important;
			background: transparent !important;
		}
	` )

	$mol_style_define( $shm_projects_image_viewer, {
		flex: { direction: 'column' },
		minWidth: 0,
		Preview: {
			width: '100%',
			height: '100%',
			minWidth: 0,
		},
		Preview_image: {
			width: '100%',
			height: '100%',
			objectFit: 'cover',
			cursor: 'zoom-in',
		},
		Overlay: {
			position: 'relative',
			width: '100%',
			height: '100%',
			alignItems: 'center',
			justifyContent: 'center',
			padding: $mol_gap.block,
			background: { color: $mol_style_func.rgba( 0, 0, 0, .9 ) },
			cursor: 'zoom-out',
		},
		Full: {
			maxWidth: '100%',
			maxHeight: '100%',
			objectFit: 'contain',
			cursor: 'zoom-out',
		},
	} )

}
